module.exports = __webpack_public_path__ + "static/media/device3.63778f03.png";